<template>
  <div>
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else-if="!showOutstandingSurveys">
      <v-row v-if="outstandingSurveyCount > 0">
        <v-col cols="12">
          <single-list-item
            color="performance"
            button-text="Complete Surveys"
            label="Reminder"
            v-on:click="showOutstandingSurveys = true"
          >
            Your have surveys that you haven't completed
          </single-list-item>
        </v-col>
      </v-row>
      <header-card
        icon="event"
        title="Survey Management"
        sub-title="Gather and view data across your team with surveys"
      >
        <template v-slot:right>
          <div class="secondary--text font-weight-medium subtitle-1">
            Total Surveys
          </div>
          <div>
            {{ surveys.length }}
          </div>
        </template>
        <template v-slot:right2>
          <engagement-text
            title="Participation Rate"
            :engagement="engagement.surveys"
            class="subtitle-1"
            click
            v-on:click="
              $router.push({ path: `/reporting/participation/surveys` })
            "
          ></engagement-text>
        </template>
        <template v-slot:extension>
          <v-divider></v-divider>
          <v-row dense>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
              <v-btn
                text
                to="/reporting/surveys/overview"
                color="secondary"
                block
              >
                <v-icon class="mr-2">assessment</v-icon>
                Reporting
              </v-btn>
            </v-col>
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-btn text color="secondary" to="/features/surveys/create" block>
                <v-icon color="primary" class="mr-2">
                  add_circle
                </v-icon>
                New Survey
              </v-btn>
            </v-col>
            <v-divider vertical></v-divider>
          </v-row>
        </template>
      </header-card>
      <v-row>
        <v-col cols="12" v-for="(survey, i) in filtered_surveys" :key="i">
          <survey-card
            :survey="survey"
            v-on:duplicate="duplicateSurvey(survey.id)"
            v-on:delete="deleteSurvey(survey.id)"
            v-on:archive="archiveSurvey(survey.id)"
          ></survey-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="auto">
          <v-btn
            text
            @click="showOutstandingSurveys = false"
            color="secondary"
            x-large
            class="font-weight-bold"
          >
            <v-icon class="mr-2">
              keyboard_arrow_left
            </v-icon>
            Go Back
          </v-btn>
        </v-col>
      </v-row>
      <survey-queue></survey-queue>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EngagementText from "@/components/reporting/EngagementText";
import SurveyCard from "@/components/surveys/SurveyCard";
import SurveyQueue from "@/components/surveys/SurveyQueue";
import HeaderCard from "@/components/common/HeaderCard";
export default {
  name: "SurveyList",
  components: {
    EngagementText,
    SurveyCard,
    SurveyQueue,
    HeaderCard
  },
  props: { initialFilter: { type: Object } },
  data: () => ({
    reportInitialFilter: null,
    search: "",
    loading: true,
    showOutstandingSurveys: false
  }),
  computed: {
    filtered_surveys() {
      let surveys = this.surveys;
      if (this.search) {
        let search = this.search.toLowerCase();
        surveys = surveys.filter(
          x => x.title.toLowerCase().indexOf(search) >= 0
        );
      }
      return surveys;
    },
    outstandingSurveyCount() {
      return this.tasks.filter(
        x => x.type == this.$enums.taskTypes.SURVEY_TO_TAKE
      ).length;
    },
    ...mapGetters({
      surveys: "survey/surveys",
      engagement: "engagement/score",
      tasks: "task/tasks"
    })
  },
  created() {
    this.getSurveys();
  },
  methods: {
    getSurveys() {
      Promise.all([
        this.$store.dispatch("survey/getSurveys"),
        this.$store.dispatch("survey/getOutstandingSurveys"),
        this.$store.dispatch("engagement/getEngagement", {
          type: this.$coreScores.SURVEY
        })
      ])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your surveys."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async duplicateSurvey(id) {
      if (
        await this.$root.$confirm(
          "Duplicate survey",
          "This action will create a duplicate version of this survey. Would you like to duplicate it and open the survey editor?",
          { color: "secondary" }
        )
      ) {
        this.$store
          .dispatch("survey/duplicateSurvey", id)
          .then(id => {
            this.$router.push({ path: `/features/surveys/${id}/builder` });
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while duplicating a survey."
            );
          });
      }
    },
    async archiveSurvey(id) {
      if (
        await this.$root.$confirm(
          "Delete survey",
          "Are you sure you want to archive this survey?",
          { color: "red" }
        )
      ) {
        this.$store
          .dispatch("survey/completeSurvey", id)
          .then(() => {
            this.$root.$snackbarSuccess("Survey archived");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while archiving this survey."
            );
          });
      }
    },
    async deleteSurvey(id) {
      if (
        await this.$root.$confirm(
          "Delete survey",
          "Are you sure you want to delete this survey?",
          { color: "red" }
        )
      ) {
        this.$store
          .dispatch("survey/deleteSurvey", id)
          .then(() => {
            this.$emit("delete");
            this.$root.$snackbarSuccess("Survey deleted");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting this survey."
            );
          });
      }
    }
  }
};
</script>
